import React from 'react';
import {NavLink} from "react-router-dom";
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import PropTypes from 'prop-types';
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from 'moment';

import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import withStyles from '@material-ui/core/styles/withStyles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import LocationSearchInput from '../utils/LocationSearchInput'
import ImgMediaCard from '../utils/ImgMediaCard'
import SearchSelect from '../utils/SearchSelect'
import Picker from '../utils/Picker'


import 'moment/locale/fr';
moment.locale('fr');

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
    height: 40
  },
  back: {
    marginTop: theme.spacing.unit * 3,
    marginRight: 20,
    height: 40
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
  input: {
    display: 'none',
  },
  media: {
    marginTop: theme.spacing.unit * 2,
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
  marginDivier: {
    marginTop: theme.spacing.unit * 3,
  }
});

class CreateAudit extends React.Component {

  render() {
    return (
      <React.Fragment>
        <CssBaseline />
          <Paper className={this.props.classes.paper}>
            <MuiPickersUtilsProvider locale="fr" moment={moment} utils={MomentUtils}>
              <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form}>
                <Grid container spacing={24}>
                  <Grid item xs={12} style={{marginBottom: 20}}>
                    <NavLink to={"/audits/"} style={{ textDecoration: 'none' }}>
                      <Button
                          variant="outlined"
                          className={this.props.classes.back}
                          size="large"
                      >Retour</Button>
                    </NavLink>
                    <Button
                        type="submit"
                        variant="raised"
                        color="primary"
                        className={this.props.classes.submit}
                        disabled={this.props.submitted}
                    >
                      {
                        (this.props.submitted && "Enregistrement en cours...") ||
                        (!this.props.submitted && "Enregister")
                      }
                    </Button>
                  </Grid>
                </Grid>

                <Typography variant="headline">Informations</Typography>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" fullWidth>
                      <Picker
                        label="Date du rendez-vous"
                        onChange={this.props.handleDateChange("date")}
                        name="date"
                        value={this.props.formData.date}
                        format="DD/MM/YYYY HH:mm"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <Picker
                          dateOnly
                          label="Date limite"
                          onChange={this.props.handleDateChange("dateLimit")}
                          name="dateLimit"
                          validators={['required']}
                          errorMessages={['ce champ est requis']}
                          value={this.props.formData.dateLimit}
                          format="DD/MM/YYYY"
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="type">Type</InputLabel>
                      <Select
                        name="type"
                        value={this.props.formData.type}
                        onChange={this.props.handleInputChange}
                        inputProps={{
                          name: 'type',
                          id:'type'
                        }}
                      >
                        {this.props.listOfAuditTypes.map(auditType => (
                          <MenuItem key={auditType.name} value={auditType.id}>
                            {auditType.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={4} >
                    <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="Nom du client (ex : M. Doe)"
                          onChange={this.props.handleInputChange}
                          name="client"
                          value={this.props.formData.client}
                          validators={['required']}
                          errorMessages={['ce champ est requis']}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={8} >
                    <LocationSearchInput address={this.props.formData.address} handleInputChange={this.props.handleInputChange} />
                  </Grid>
                  <Grid item xs={12} md={6} >
                    {this.props.formData.type && (
                        <FormControl margin="normal" required fullWidth>
                          <SearchSelect name="qualifications" label="Qualification(s)" placeholder="Liste des qualification(s)" defaultValue={this.props.formData.qualifications} options={this.props.listOfQualifications.filter(x => x.speciality.activity.family.audit_type.id === this.props.formData.type)} handleInputChange={this.props.handleInputChange} />
                        </FormControl>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} >
                    {this.props.formData.type && (
                      <FormControl margin="normal" required fullWidth>
                        <SearchSelect name="mentions" label="Mention(s)" placeholder="Liste des mention(s)" defaultValue={this.props.formData.mentions} options={this.props.listOfMentions.filter(x => x.audit_type.id === this.props.formData.type)} handleInputChange={this.props.handleInputChange} />
                      </FormControl>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label={"Pré-remplir avec la référence d'audit..."}
                            onChange={this.props.handleAuditNumChange}
                            name="auditNum"
                            placeholder={"ex.: XXXX-XXXX-XXXX-EETI-38"}
                            value={this.props.auditNum}
                        />
                    </FormControl>
                </Grid>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Référence de l'audit"
                            onChange={this.props.handleInputChange}
                            name="reference"
                            value={this.props.formData.reference}
                            validators={['required']}
                            errorMessages={['ce champ est requis']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Lot n°"
                            onChange={this.props.handleInputChange}
                            name="lot"
                            value={this.props.formData.lot}
                        />
                    </FormControl>
                  </Grid>

                </Grid>

                <Grid container spacing={24}>
                  <Grid item xs={12} sm={12} md={4}>
                    <Typography variant="button" >Plan d'audit</Typography>
                    <FormControl margin="normal" required fullWidth>
                      <input
                        accept="image/*"
                        className={this.props.classes.input}
                        onChange={this.props.handleFileChange}
                        id="summary"
                        name="summary"
                        type="file"
                      />
                      <label htmlFor="summary">
                        <Button variant="contained" component="span" >
                          {(this.props.formData.summary && Object.keys(this.props.formData.summary).length > 0) ? "Remplacer" : "Envoyer"}
                        </Button>
                      </label>
                      {(this.props.formData.summary && Object.keys(this.props.formData.summary).length > 0) &&
                        <ImgMediaCard
                          title="Plan d'audit"
                          image={this.props.formData.summary.path}
                          onDelete={this.props.displayConfirmation}
                          deleteCallback={() => this.props.handleFileRemove("summary")}
                        />}
                    </FormControl>
                  </Grid>
                </Grid>

                <Typography variant="headline" className={this.props.classes.marginDivier}>Entreprise audité</Typography>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Siret"
                            onChange={(e) => this.props.handleInputChange(e, 'company')}
                            name="siret"
                            value={this.props.formData.company.siret}
                            validators={['required', 'matchRegexp:^[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{5}$']}
                            errorMessages={['ce champ est requis', 'Le siret doit être au format 123 456 789 12345']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Raison sociale"
                            onChange={(e) => this.props.handleInputChange(e, 'company')}
                            name="name"
                            value={this.props.formData.company.name}
                            validators={['required']}
                            errorMessages={['ce champ est requis']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Référence de l'entreprise"
                            onChange={(e) => this.props.handleInputChange(e, 'company')}
                            name="reference_company"
                            value={this.props.formData.company.reference}
                            validators={['required']}
                            errorMessages={['ce champ est requis']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Nom du responsable"
                            onChange={(e) => this.props.handleInputChange(e, 'company')}
                            name="manager"
                            value={this.props.formData.company.manager}
                            validators={['required']}
                            errorMessages={['ce champ est requis']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Téléphone"
                            onChange={(e) => this.props.handleInputChange(e, 'company')}
                            name="phone"
                            value={this.props.formData.company.phone}
                            validators={['required', 'matchRegexp:^[ 0-9]*$']}
                            errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Email"
                            onChange={(e) => this.props.handleInputChange(e, 'company')}
                            name="email"
                            value={this.props.formData.company.email}
                            validators={['required', 'isEmail']}
                            errorMessages={['ce champ est requis', 'email is not valid']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Département (ex : 75)"
                            onChange={(e) => this.props.handleInputChange(e, 'company')}
                            name="department"
                            value={this.props.formData.company.department}
                            validators={['required', 'matchRegexp:^[0-9]*$']}
                            errorMessages={['ce champ est requis', 'Numéro de département invalide']}
                        />
                    </FormControl>
                  </Grid>

                </Grid>

                <Button

                      type="submit"
                      variant="raised"
                      color="primary"
                      className={this.props.classes.submit}
                      disabled={this.props.submitted}
                  >
                      {
                          (this.props.submitted && "Enregistrement en cours...") ||
                          (!this.props.submitted && "Enregister")
                      }
                  </Button>
              </ValidatorForm>
            </MuiPickersUtilsProvider>
          </Paper>
      </React.Fragment>
    );
  }
}

CreateAudit.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateAudit);



// WEBPACK FOOTER //
// ./src/component/audit/createAudit.js